import { oktaAuth } from './oktaInstance';
import { getOktaTokens } from '../api/getOktaTokens';
import { validateTokenExp } from './tokenManager';

/**
 * Attempts to renew the idToken and reports whether a valid (non-expired)
 * idToken exists afterward.
 *
 * Shared by the request middleware (pre-flight expiry check) and
 * handleRequestError (server UnauthorizedException) so both use the same
 * renew-then-recheck logic. Returns false when renewal throws or the refreshed
 * token is still expired — the caller then decides whether to sign the user out.
 */
export const renewIdToken = async (): Promise<boolean> => {
  try {
    await oktaAuth.tokenManager.renew('idToken');
  } catch (error) {
    console.error('Failed to renew idToken:', error);
    return false;
  }

  const { idToken } = getOktaTokens();
  return !!idToken && validateTokenExp(idToken);
};
